import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterStorageGroup';

export type WaterStorageGroupProps = {
  totalStorageCapacity?: number;
  fillLevel?: number;
  availableCapacity?: number;
  fillLevelHistory?: number;
  capacityAvailablityHistory?: number;
  changeInLastPeriod?: number;
  changeInNextPeriod?: number;
  comparePeriods?: number;
};

export class WaterStorageGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  totalStorageCapacity?: number;
  fillLevel?: number;

  availableCapacity?: number;
  fillLevelHistory?: number;
  capacityAvailablityHistory?: number;
  changeInLastPeriod?: number;
  changeInNextPeriod?: number;
  comparePeriods?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      totalStorageCapacity: {
        type: 'Number',
        editable: true,
        label: 'Total Storage Capacity',
        name: 'totalStorageCapacity',
        description: 'Total water storage capacity across grouped Water Storage objects',
      },
      fillLevel: {
        type: 'Number',
        editable: true,
        label: 'Fill Level',
        name: 'fillLevel',
        description: 'Current fill level %/ l/ cubic metres for grouped and individual WS objects ',
      },
      availableCapacity: {
        type: 'Number',
        editable: true,
        label: 'Available Capacity',
        name: 'availableCapacity',
        description: 'Volume of available capacity (l/ cubic metres); % for grouped and individual WS objects',
      },
      fillLevelHistory: {
        type: 'Number',
        editable: true,
        label: 'Fill Level History',
        name: 'fillLevelHistory',
        description: 'Fill level in previous periods, days, weeks, months, years, seasons',
      },
      capacityAvailablityHistory: {
        type: 'Number',
        editable: true,
        label: 'Capacity Availablity History',
        name: 'capacityAvailablityHistory',
        description: 'Available capacity in previous periods, days, weeks, months, years, seasons',
      },
      changeInLastPeriod: {
        type: 'Number',
        editable: true,
        label: 'Change in last period',
        name: 'changeInLastPeriod',
        description: 'Change in fill level and availabile capacity from last period',
      },
      changeInNextPeriod: {
        type: 'Number',
        editable: true,
        label: 'Change in next period',
        name: 'changeInNextPeriod',
        description: 'Forecast change in fill level and availabile capacity in next period based on consumption, water take andrain forecast',
      },
      comparePeriods: { type: 'Number', editable: true, label: 'Compare periods', name: 'comparePeriods', description: 'Compare periods' },
    };
  };
}
